import { gql } from '@apollo/client';

const getMyMcpKeys = gql`
  query GetMyMcpKeys {
    getMyMcpKeys {
      id
      key_prefix
      label
      scopes
      expires_at
      revoked_at
      last_used_at
      createdAt
    }
  }
`;

export default getMyMcpKeys;
